import React, { Component } from 'react';
import {
  Box,
  Typography,
  Breadcrumbs,
  Link,
  Button,
  Grid,
  Paper,
  TextField,
  InputAdornment,
  Chip,
  Avatar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  MenuItem,
  CircularProgress
} from '@mui/material';

// Ícones MUI
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
import WorkOutlinedIcon from '@mui/icons-material/WorkOutlined';
import HeadsetMicOutlinedIcon from '@mui/icons-material/HeadsetMicOutlined';
import SoupKitchenOutlinedIcon from '@mui/icons-material/SoupKitchenOutlined';
import CalculateOutlinedIcon from '@mui/icons-material/CalculateOutlined';
import SearchIcon from '@mui/icons-material/Search';
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';

// Ícones dos Chips/Tags
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import InsertChartOutlinedIcon from '@mui/icons-material/InsertChartOutlined';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import { apiUrl } from '../../comp/ApiUrl'; // Certifique-se de que o caminho para o arquivo config.js está correto
// Ícones de Ações da Tabela
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import VpnKeyOutlinedIcon from '@mui/icons-material/VpnKeyOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

const API_URL = apiUrl + '/members';

class PerfisDeAcesso extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchQuery: '',
      membros: [],
      loading: false,

      // Modal para Criar/Editar Membro
      openModal: false,
      membroEditando: null,
      formData: {
        nome: '',
        email: '',
        funcao: 'Atendente',
        senha: '' // Senha usada no cadastro inicial
      },

      // Modal para Resetar Senha
      openResetSenhaModal: false,
      membroResetSenha: null,
      novaSenha: ''
    };
  }

  componentDidMount() {
    this.buscarMembros();
  }

  // 1. LISTAR MEMBROS (GET)
  buscarMembros = async () => {
    fetch(`${API_URL}`, {
      credentials: "include",
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({ membros: data, loading: false });
      })
      .catch((error) => {
        console.error('Erro ao buscar membros:', error);
        this.setState({ loading: false });
      });
  };

  handleSearchChange = (event) => {
    this.setState({ searchQuery: event.target.value });
  };

  // Controles do Modal Principal (Criar/Editar)
  handleOpenModal = (membro = null) => {
    if (membro) {
      this.setState({
        openModal: true,
        membroEditando: membro,
        formData: {
          nome: membro.nome,
          email: membro.email,
          funcao: membro.funcao,
          senha: '' // Ao editar, a senha fica vazia (só altera se o usuário preencher)
        }
      });
    } else {
      this.setState({
        openModal: true,
        membroEditando: null,
        formData: { nome: '', email: '', funcao: 'Atendente', senha: '' }
      });
    }
  };

  handleCloseModal = () => {
    this.setState({
      openModal: false,
      membroEditando: null,
      formData: { nome: '', email: '', funcao: 'Atendente', senha: '' }
    });
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      formData: { ...prevState.formData, [name]: value }
    }));
  };

  // 2. ADICIONAR / EDITAR MEMBRO (POST / PUT)
  handleSalvarMembro = async (e) => {
    e.preventDefault();
    const { membroEditando, formData } = this.state;

    try {
      if (membroEditando) {
        // EDITAR (PUT)
        const payload = {
          nome: formData.nome,
          email: formData.email,
          funcao: formData.funcao
        };
        // Envia a senha apenas se o usuário preencheu o campo
        if (formData.senha) payload.senha = formData.senha;

        const response = await fetch(`${API_URL}/${membroEditando.id}`, {
          credentials: "include",
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });

        if (response.ok) {
          const membroAtualizado = await response.json();
          this.setState((prevState) => ({
            membros: prevState.membros.map((m) =>
              m.id === membroEditando.id ? membroAtualizado : m
            )
          }));
        }
      } else {
        // ADICIONAR (POST)
        const response = await fetch(API_URL, {
          credentials: "include",
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            ...formData,
            status: 'Ativo',
            criadoEm: new Date().toLocaleDateString('pt-BR')
          })
        });

        if (response.ok) {
          const novoMembro = await response.json();
          this.setState((prevState) => ({
            membros: [...prevState.membros, novoMembro]
          }));
        }
      }
      this.handleCloseModal();
    } catch (error) {
      console.error('Erro ao salvar membro:', error);
    }
  };

  // 3. ALTERAR STATUS (PATCH)
  handleToggleStatus = async (membro) => {
    const novoStatus = membro.status === 'Ativo' ? 'Inativo' : 'Ativo';
    try {
      const response = await fetch(`${API_URL}/${membro.id}`, {
        credentials: "include",
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ status: novoStatus })
      });

      if (response.ok) {
        this.setState((prevState) => ({
          membros: prevState.membros.map((m) =>
            m.id === membro.id ? { ...m, status: novoStatus } : m
          )
        }));
      }
    } catch (error) {
      console.error('Erro ao alterar status:', error);
    }
  };

  // 4. RESET DE SENHA ESPECÍFICO (PATCH)
  handleOpenResetSenha = (membro) => {
    this.setState({
      openResetSenhaModal: true,
      membroResetSenha: membro,
      novaSenha: ''
    });
  };

  handleCloseResetSenha = () => {
    this.setState({
      openResetSenhaModal: false,
      membroResetSenha: null,
      novaSenha: ''
    });
  };

  handleSalvarNovaSenha = async (e) => {
    e.preventDefault();
    const { membroResetSenha, novaSenha } = this.state;

    try {
      const response = await fetch(`${API_URL}/${membroResetSenha.id}/reset-senha`, {
        credentials: "include",
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ senha: novaSenha })
      });

      if (response.ok) {
        alert(`Senha do usuário ${membroResetSenha.nome} alterada com sucesso!`);
        this.handleCloseResetSenha();
      }
    } catch (error) {
      console.error('Erro ao resetar senha:', error);
    }
  };

  // 5. REMOVER MEMBRO (DELETE)
  handleRemoverMembro = async (id) => {
    if (!window.confirm('Tem certeza que deseja remover este membro?')) return;

    try {
      const response = await fetch(`${API_URL}/${id}`, {
        credentials: "include",
        method: 'DELETE'
      });

      if (response.ok) {
        this.setState((prevState) => ({
          membros: prevState.membros.filter((m) => m.id !== id)
        }));
      }
    } catch (error) {
      console.error('Erro ao remover membro:', error);
    }
  };

  render() {
    const {
      searchQuery,
      membros,
      loading,
      openModal,
      membroEditando,
      formData,
      openResetSenhaModal,
      membroResetSenha,
      novaSenha
    } = this.state;

    const perfis = [
      {
        id: 'proprietario',
        titulo: 'Proprietário',
        icon: <EmojiEventsOutlinedIcon fontSize="small" />,
        iconColor: '#d97706',
        iconBg: '#fef3c7',
        descricao: (
          <span>
            Dono da conta. Acesso total a todas as áreas e configurações. <strong>Não pode ser removido.</strong>
          </span>
        ),
        tags: [{ label: '👑 Tudo' }]
      },
      {
        id: 'gerente',
        titulo: 'Gerente',
        icon: <WorkOutlinedIcon fontSize="small" />,
        iconColor: '#7c3aed',
        iconBg: '#f3e8ff',
        descricao: (
          <span>
            Administra a operação do dia a dia. Acesso amplo para configurar e acompanhar pedidos, <strong>sem acesso a faturamento e exclusão da conta.</strong>
          </span>
        ),
        tags: [
          { label: 'Pedidos', icon: <AssignmentOutlinedIcon style={{ fontSize: 14 }} /> },
          { label: 'Cardápio', icon: <LocalOfferOutlinedIcon style={{ fontSize: 14 }} /> },
          { label: 'Clientes', icon: <PeopleAltOutlinedIcon style={{ fontSize: 14 }} /> },
          { label: 'Entregas', icon: <LocalShippingOutlinedIcon style={{ fontSize: 14 }} /> },
          { label: 'Relatórios', icon: <InsertChartOutlinedIcon style={{ fontSize: 14 }} /> },
          { label: 'WhatsApp', icon: <WhatsAppIcon style={{ fontSize: 14 }} /> },
          { label: 'Configurações', icon: <SettingsOutlinedIcon style={{ fontSize: 14 }} /> },
          { label: 'Finanças', icon: <AccessTimeOutlinedIcon style={{ fontSize: 14 }} /> }
        ]
      },
      {
        id: 'atendente',
        titulo: 'Atendente',
        icon: <HeadsetMicOutlinedIcon fontSize="small" />,
        iconColor: '#0d9488',
        iconBg: '#ccfbf1',
        descricao: (
          <span>
            Atende clientes no WhatsApp e gerencia pedidos. <strong>Ideal para equipe de atendimento e balcão.</strong>
          </span>
        ),
        tags: [
          { label: 'Pedidos', icon: <AssignmentOutlinedIcon style={{ fontSize: 14 }} /> },
          { label: 'WhatsApp', icon: <WhatsAppIcon style={{ fontSize: 14 }} /> },
          { label: 'Clientes', icon: <PeopleAltOutlinedIcon style={{ fontSize: 14 }} /> }
        ]
      },
      {
        id: 'cozinha',
        titulo: 'Cozinha',
        icon: <SoupKitchenOutlinedIcon fontSize="small" />,
        iconColor: '#c2410c',
        iconBg: '#ffedd5',
        descricao: (
          <span>
            Visualiza apenas a produção. Recebe e acompanha pedidos no painel da cozinha (KDS).
          </span>
        ),
        tags: [
          { label: 'Pedidos (somente visualização do board/KDS)', icon: <AssignmentOutlinedIcon style={{ fontSize: 14 }} /> }
        ]
      },
      {
        id: 'financeiro',
        titulo: 'Financeiro',
        icon: <CalculateOutlinedIcon fontSize="small" />,
        iconColor: '#6b21a8',
        iconBg: '#f3e8ff',
        descricao: (
          <span>
            Acompanha resultados e movimentações. <strong>Acesso a relatórios, gestão financeira e faturas.</strong>
          </span>
        ),
        tags: [
          { label: 'Relatórios', icon: <InsertChartOutlinedIcon style={{ fontSize: 14 }} /> },
          { label: 'Finanças', icon: <AccessTimeOutlinedIcon style={{ fontSize: 14 }} /> },
          { label: 'Faturas', icon: <ReceiptOutlinedIcon style={{ fontSize: 14 }} /> },
          { label: 'Estoque', icon: <Inventory2OutlinedIcon style={{ fontSize: 14 }} /> },
          { label: 'Compras', icon: <ShoppingCartOutlinedIcon style={{ fontSize: 14 }} /> }
        ]
      }
    ];

    const membrosFiltrados = membros.filter(
      (m) =>
        m.nome.toLowerCase().includes(searchQuery.toLowerCase()) ||
        m.email.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
      <Box sx={{ minHeight: '100vh', p: 0, fontFamily: 'Inter, Roboto, sans-serif' }}>
        {/* Breadcrumbs e Título */}
        <Box sx={{ mb: 3 }}>
          <Breadcrumbs separator="/" aria-label="breadcrumb" sx={{ fontSize: '0.875rem', mb: 1, color: '#6b7280' }}>
            <Link underline="hover" color="inherit" href="#">
              Início
            </Link>
            <Link underline="hover" color="inherit" href="#">
              Configurações
            </Link>
            <Typography color="text.primary" fontSize="0.875rem">
              Perfis de Acesso
            </Typography>
          </Breadcrumbs>

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Avatar sx={{ bgcolor: '#f3e8ff', color: '#6b21a8', width: 40, height: 40 }}>
              <GroupOutlinedIcon />
            </Avatar>
            <Typography variant="h4" sx={{ fontWeight: 700, color: '#111827', fontSize: '1.75rem' }}>
              Perfis de Acesso
            </Typography>
          </Box>
          <Typography variant="body2" sx={{ color: '#6b7280', mt: 0.5 }}>
            Gerencie os membros da sua equipe e suas permissões.
          </Typography>
        </Box>

        {/* Grid de Perfis */}
        <Grid container spacing={2} sx={{ mb: 4 }}>
          {perfis.map((perfil) => (
            <Grid item size={{ xs: 12, sm: 3, md: 4 }} key={perfil.id}>
              <Paper
                elevation={0}
                sx={{
                  p: 2.5,
                  borderRadius: '16px',
                  border: '1px solid #e5e7eb',
                  bgcolor: '#ffffff',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between'
                }}
              >
                <Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
                    <Avatar
                      variant="rounded"
                      sx={{
                        bgcolor: perfil.iconBg,
                        color: perfil.iconColor,
                        borderRadius: '10px',
                        width: 36,
                        height: 36
                      }}
                    >
                      {perfil.icon}
                    </Avatar>
                    <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#111827' }}>
                      {perfil.titulo}
                    </Typography>
                  </Box>

                  <Typography variant="body2" sx={{ color: '#4b5563', fontSize: '0.8125rem', lineHeight: 1.5, mb: 2 }}>
                    {perfil.descricao}
                  </Typography>
                </Box>

                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.8, mt: 'auto' }}>
                  {perfil.tags.map((tag, index) => (
                    <Chip
                      key={index}
                      icon={tag.icon || undefined}
                      label={tag.label}
                      size="small"
                      sx={{
                        bgcolor: '#f3f4f6',
                        color: '#374151',
                        fontSize: '0.75rem',
                        fontWeight: 500,
                        height: 24,
                        '& .MuiChip-icon': { color: '#6b7280', marginLeft: '6px' }
                      }}
                    />
                  ))}
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>

        {/* Pesquisa e Botão Adicionar */}
        <Box sx={{ display: 'flex', gap: 2, mb: 2, alignItems: 'center' }}>
          <TextField
            fullWidth
            placeholder="Pesquisar membros..."
            value={searchQuery}
            onChange={this.handleSearchChange}
            variant="outlined"
            size="small"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: '#9ca3af' }} />
                </InputAdornment>
              ),
              sx: {
                borderRadius: '10px',
                backgroundColor: '#ffffff',
                '& fieldset': { borderColor: '#e5e7eb' },
                '&:hover fieldset': { borderColor: '#d1d5db' },
                fontSize: '0.875rem'
              }
            }}
          />
          <Button
            variant="contained"
            startIcon={<PersonAddOutlinedIcon />}
            onClick={() => this.handleOpenModal()}
            sx={{
              borderRadius: '10px',
              textTransform: 'none',
              bgcolor: '#6b21a8',
              color: '#ffffff',
              fontWeight: 600,
              whiteSpace: 'nowrap',
              px: 3,
              height: 40,
              boxShadow: 'none',
              '&:hover': { bgcolor: '#581c87', boxShadow: 'none' }
            }}
          >
            Adicionar Membro
          </Button>
        </Box>

        {/* Tabela de Membros */}
        <TableContainer
          component={Paper}
          elevation={0}
          sx={{
            borderRadius: '12px',
            border: '1px solid #e5e7eb',
            bgcolor: '#ffffff'
          }}
        >
          <Table>
            <TableHead>
              <TableRow sx={{ bgcolor: '#fafafa' }}>
                <TableCell sx={{ color: '#374151', fontWeight: 700, fontSize: '0.75rem', letterSpacing: '0.05em' }}>
                  MEMBRO
                </TableCell>
                <TableCell sx={{ color: '#374151', fontWeight: 700, fontSize: '0.75rem', letterSpacing: '0.05em' }}>
                  EMAIL
                </TableCell>
                <TableCell sx={{ color: '#374151', fontWeight: 700, fontSize: '0.75rem', letterSpacing: '0.05em' }}>
                  FUNÇÃO
                </TableCell>
                <TableCell sx={{ color: '#374151', fontWeight: 700, fontSize: '0.75rem', letterSpacing: '0.05em' }}>
                  STATUS
                </TableCell>
                <TableCell sx={{ color: '#374151', fontWeight: 700, fontSize: '0.75rem', letterSpacing: '0.05em' }}>
                  CRIADO EM
                </TableCell>
                <TableCell align="right" sx={{ color: '#374151', fontWeight: 700, fontSize: '0.75rem', letterSpacing: '0.05em' }}>
                  AÇÕES
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={6} align="center" sx={{ py: 3 }}>
                    <CircularProgress size={30} />
                  </TableCell>
                </TableRow>
              ) : membrosFiltrados.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={6} align="center" sx={{ py: 3, color: '#6b7280' }}>
                    Nenhum membro encontrado.
                  </TableCell>
                </TableRow>
              ) : (
                membrosFiltrados.map((membro) => (
                  <TableRow key={membro.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                    <TableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        <Avatar sx={{ bgcolor: '#ffedd5', color: '#c2410c', width: 34, height: 34 }}>

                        </Avatar>
                        <Typography variant="body2" sx={{ fontWeight: 600, color: '#111827' }}>
                          {membro.nome}
                        </Typography>
                      </Box>
                    </TableCell>

                    <TableCell sx={{ color: '#4b5563', fontSize: '0.875rem' }}>
                      {membro.email}
                    </TableCell>

                    <TableCell>
                      <Chip
                        label={membro.funcao}
                        size="small"
                        sx={{
                          bgcolor: '#ffedd5',
                          color: '#c2410c',
                          fontWeight: 600,
                          fontSize: '0.75rem',
                          borderRadius: '6px'
                        }}
                      />
                    </TableCell>

                    <TableCell>
                      <Chip
                        label={membro.status}
                        size="small"
                        sx={{
                          bgcolor: membro.status === 'Ativo' ? '#dcfce7' : '#f3f4f6',
                          color: membro.status === 'Ativo' ? '#15803d' : '#4b5563',
                          fontWeight: 600,
                          fontSize: '0.75rem',
                          borderRadius: '6px'
                        }}
                      />
                    </TableCell>

                    <TableCell sx={{ color: '#4b5563', fontSize: '0.875rem' }}>
                      {new Date(membro.created_at).toLocaleDateString('pt-BR')}
                    </TableCell>

                    <TableCell align="right">
                      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 0.5 }}>
                        <IconButton
                          size="small"
                          sx={{ color: membro.status === 'Ativo' ? '#16a34a' : '#9ca3af' }}
                          onClick={() => this.handleToggleStatus(membro)}
                          title="Alternar Status"
                        >
                          <PowerSettingsNewIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                          size="small"
                          sx={{ color: '#4b5563' }}
                          onClick={() => this.handleOpenModal(membro)}
                          title="Editar"
                        >
                          <EditOutlinedIcon fontSize="small" />
                        </IconButton>

                        {/* Ícone da Chave para Redefinir Senha */}
                        <IconButton
                          size="small"
                          sx={{ color: '#4b5563' }}
                          onClick={() => this.handleOpenResetSenha(membro)}
                          title="Alterar Senha / PIN"
                        >
                          <VpnKeyOutlinedIcon fontSize="small" />
                        </IconButton>

                        <IconButton
                          size="small"
                          sx={{ color: '#ef4444' }}
                          onClick={() => this.handleRemoverMembro(membro.id)}
                          title="Remover"
                        >
                          <DeleteOutlineIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* MODAL 1: Adicionar/Editar Membro */}
        <Dialog open={openModal} onClose={this.handleCloseModal} fullWidth maxWidth="sm">
          <form onSubmit={this.handleSalvarMembro}>
            <DialogTitle sx={{ fontWeight: 700 }}>
              {membroEditando ? 'Editar Membro' : 'Adicionar Membro'}
            </DialogTitle>
            <DialogContent dividers>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
                <TextField
                  label="Nome do Operador / Funcionário"
                  name="nome"
                  value={formData.nome}
                  onChange={this.handleInputChange}
                  fullWidth
                  required
                />
                <TextField
                  label="E-mail / Usuário de Acesso"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={this.handleInputChange}
                  fullWidth
                  required
                />
                <TextField
                  select
                  label="Função"
                  name="funcao"
                  value={formData.funcao}
                  onChange={this.handleInputChange}
                  fullWidth
                >
                  <MenuItem value="Proprietário">Proprietário</MenuItem>
                  <MenuItem value="Gerente">Gerente</MenuItem>
                  <MenuItem value="Atendente">Atendente (Balcão)</MenuItem>
                  <MenuItem value="Cozinha">Cozinha (KDS)</MenuItem>
                  <MenuItem value="Financeiro">Financeiro</MenuItem>
                </TextField>

                {/* Campo de Senha obrigatório na criação, opcional na edição */}
                <TextField
                  label={membroEditando ? 'Nova Senha / PIN (deixe em branco para não alterar)' : 'Senha / PIN de Acesso'}
                  name="senha"
                  type="password"
                  value={formData.senha}
                  onChange={this.handleInputChange}
                  fullWidth
                  required={!membroEditando}
                />
              </Box>
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
              <Button onClick={this.handleCloseModal} color="inherit">
                Cancelar
              </Button>
              <Button type="submit" variant="contained" sx={{ bgcolor: '#6b21a8', '&:hover': { bgcolor: '#581c87' } }}>
                {membroEditando ? 'Salvar Alterações' : 'Adicionar'}
              </Button>
            </DialogActions>
          </form>
        </Dialog>

        {/* MODAL 2: Resetar Senha (via Ícone de Chave) */}
        <Dialog open={openResetSenhaModal} onClose={this.handleCloseResetSenha} fullWidth maxWidth="xs">
          <form onSubmit={this.handleSalvarNovaSenha}>
            <DialogTitle sx={{ fontWeight: 700 }}>
              Alterar Senha / PIN
            </DialogTitle>
            <DialogContent dividers>
              <Typography variant="body2" sx={{ mb: 2, color: '#4b5563' }}>
                Defina uma nova senha para <strong>{membroResetSenha?.nome}</strong> ({membroResetSenha?.funcao}):
              </Typography>
              <TextField
                label="Nova Senha ou PIN"
                type="password"
                value={novaSenha}
                onChange={(e) => this.setState({ novaSenha: e.target.value })}
                fullWidth
                required
                autoFocus
              />
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
              <Button onClick={this.handleCloseResetSenha} color="inherit">
                Cancelar
              </Button>
              <Button type="submit" variant="contained" sx={{ bgcolor: '#6b21a8', '&:hover': { bgcolor: '#581c87' } }}>
                Atualizar Senha
              </Button>
            </DialogActions>
          </form>
        </Dialog>
      </Box>
    );
  }
}

export default PerfisDeAcesso;